import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6848a74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card border-0 rounded-2 shadow-sm bg-white mb-4" }
const _hoisted_2 = { class: "card-header bg-light py-3 px-4 border-0 d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "fw-bold text-primary mb-0" }
const _hoisted_4 = { class: "badge bg-success-subtle text-success fw-semibold fs-13 px-3 py-2" }
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = { class: "row gy-4" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Código", -1))
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Nombre", -1))
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Versión", -1))
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Descripción", -1))
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "HTML Contenido", -1))
const _hoisted_17 = { class: "col-md-12 mt-4" }
const _hoisted_18 = { class: "fw-bold text-primary mb-3 d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-variable fs-18 me-2 text-success" }, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "badge bg-success text-white ms-2 fs-12"
}
const _hoisted_21 = {
  key: 0,
  class: "row g-3"
}
const _hoisted_22 = { class: "variable-card p-3 bg-white border border-success-subtle rounded shadow-sm d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-code fs-16 text-success me-2" }, null, -1))
const _hoisted_24 = { class: "fw-semibold text-dark" }
const _hoisted_25 = {
  key: 1,
  class: "alert alert-secondary rounded mt-3 p-3 text-center fw-medium"
}
const _hoisted_26 = { class: "col-md-12 mt-4 d-flex justify-content-between align-items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-save me-2" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-close me-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.form.record.Id ? "Editar plantilla" : "Nueva plantilla"), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.form.record.Version ? `Versión ${_ctx.form.record.Version}` : "Sin versión"), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_b_form, {
        ref: "formRecord",
        id: "formTemplate",
        onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_container, { fluid: "" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Code,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.Code) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: TMP-001",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.Name) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Bienvenida Aurora",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Version,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.Version) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "1.0"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_b_form_textarea, {
                    modelValue: _ctx.form.record.Description,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.Description) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    rows: "3",
                    placeholder: "Describe brevemente la función de esta plantilla..."
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_b_form_textarea, {
                    modelValue: _ctx.form.record.HtmlContent,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.HtmlContent) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    rows: "10",
                    placeholder: "Describe brevemente la función de esta plantilla..."
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h6", _hoisted_18, [
                    _hoisted_19,
                    _createTextVNode(" Variables capturadas "),
                    (_ctx.variables.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.variables.length), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.variables.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variables, (variable, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "col-md-4 col-lg-3",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_22, [
                              _hoisted_23,
                              _createElementVNode("span", _hoisted_24, _toDisplayString(variable), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, " No se detectaron variables en esta plantilla. "))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_b_button, {
                    class: "default-btn border-0 fw-semibold text-white px-4 py-2 bg-success",
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27,
                      _createTextVNode(" " + _toDisplayString(_ctx.form.record.Id ? "Guardar Cambios" : "Crear Plantilla"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_button, {
                    onClick: _ctx.cancel,
                    class: "bg-transparent border-0 text-danger fw-semibold"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28,
                      _createTextVNode(" Cancelar ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}